import { date } from "src/utils/date";
import { Data } from "@angular/router";

export class TextRequestMessage {
  Body: string;
  InternalId: string;
  RegionId: string;
  FeatureId: string;
  Data: string;
  OrganizationId: string;
  SendTo: string;
  SendFrom: string;
  ScheduledAt: Date;
  SendOutAt: Date;
}


